import CreateCampaign from '@/modules/campaign-manage/pages/CreateCampaign'
import { EventBus } from '@/core/EventBus'
import router from '@/core/router'
import CampaignReport from '@/modules/campaign-manage/pages/CampaignReport.vue'
import { $hasFeature } from '@/core/utils/VueAcl'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'

const forbiddenPage = route => {
  return {
    name: 'Forbidden',
    params: [route.path],
    query: route.query,
    replace: true
  }
}

const validateWorkflowAccess = (to, from, next) => {
  const isWorkflowCampaign =
    parseInt(to.query.type) === campaignTypeEnum.TYPE_WORKFLOW
  const isNewCampaign = !to.query.id

  if (isWorkflowCampaign && isNewCampaign) {
    const hasMaxAutomation = $hasFeature('maxautomation')
    const newMxaValue = parseInt(to.query.new_mxa)

    // Block access to JB1 campaigns when feature flags are disabled
    const isJb1Campaign = newMxaValue === 0
    const isJb1Enabled = $hasFeature('legacyMxaEnabled')

    // Block access to JB2 campaigns when feature flags are disabled
    const isJb2Campaign = newMxaValue === 1
    const isJb2Enabled = $hasFeature('newMxa')

    if (
      !hasMaxAutomation ||
      (isJb1Campaign && !isJb1Enabled) ||
      (isJb2Campaign && !isJb2Enabled)
    ) {
      next(forbiddenPage(to))
      return
    }
  }

  next()
}

export default [
  {
    name: 'UpdateCampaign',
    path: '/push/campaign/update',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'CopyCampaign',
    path: '/push/campaign/copy',
    component: CreateCampaign,
    meta: {
      auth: ['createProjectItem']
    }
  },
  {
    name: 'ViewCampaign',
    path: '/push/campaign/view',
    component: CreateCampaign,
    meta: {
      auth: ['viewProjectItem']
    }
  },
  {
    name: 'ViewCampaignSnapshot',
    path: '/push/campaign/snapshot',
    component: CreateCampaign,
    meta: {
      auth: ['AuditLog:ReadAccess']
    }
  },
  {
    name: 'CreateCampaign',
    path: '/push/campaign/create',
    component: CreateCampaign,
    beforeEnter: (to, from, next) => {
      validateWorkflowAccess(to, from, next)
    },
    meta: {
      action: toRoute => {
        if (router.currentRoute.name === toRoute.name) {
          EventBus.$emit('show-confirmation-before-create-dialog', toRoute)
        } else {
          EventBus.$emit('show-campaign-create-dialog', toRoute)
        }
      },
      avoid_action_query_params: ['type'],
      title: 'LeftNavigation_CreateCampaign',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'CampaignReport',
    path: '/push/campaign/report/create',
    component: CampaignReport,
    meta: {
      title: 'CampaignReport_Tab_Title',
      auth: ['exportCampaignAnalytics']
    }
  },
  {
    name: 'UpdateCampaignReport',
    path: '/push/campaign/report/update',
    component: CampaignReport,
    meta: {
      title: 'CampaignReport',
      auth: ['exportCampaignAnalytics']
    }
  },
  {
    name: 'CreateTemplateCampaign',
    path: '/push/campaign/template/create',
    component: CreateCampaign,
    beforeEnter: (to, from, next) => {
      validateWorkflowAccess(to, from, next)
    },
    meta: {
      action: toRoute => {
        if (router.currentRoute.name === toRoute.name) {
          EventBus.$emit('show-confirmation-before-create-dialog', toRoute)
        } else {
          EventBus.$emit('show-campaign-template-create-dialog', toRoute)
        }
      },
      avoid_action_query_params: ['type'],
      title: 'LeftNavigation_TemplateCampaigns',
      auth: ['createProjectItem']
    }
  },
  {
    name: 'UpdateTemplateCampaign',
    path: '/push/campaign/template/update',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'CopyTemplateCampaign',
    path: '/push/campaign/template/copy',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'ViewTemplateCampaign',
    path: '/push/campaign/template/view',
    component: CreateCampaign,
    meta: {
      auth: ['updateProjectItem']
    }
  },
  {
    name: 'CreateFromTemplate',
    path: '/push/campaign/template/create-from',
    component: CreateCampaign,
    meta: {
      auth: ['createProjectItem']
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/router/index.js